import React, { ReactNode } from 'react';

type ColumnProps = {
  children?: ReactNode;
  'data-testid'?: string;
};

const Root: React.FC<{ children: ReactNode; 'data-testid'?: string }> = ({
  children,
  'data-testid': testId = 'two-column-layout',
}) => {
  const [leftColumn, rightColumn] = React.Children.toArray(children);

  return (
    <div
      className="grid w-full"
      style={{
        gridTemplateColumns: 'minmax(0, 1fr) 1px minmax(0, 250px)',
      }}
      data-testid={testId}
    >
      <div
        className="flex flex-1 flex-col pr-8"
        data-testid={`${testId}-left-container`}
      >
        {leftColumn}
      </div>
      <div
        className="hidden w-px self-stretch bg-gray-300 sm:block"
        data-testid={`${testId}-divider`}
      ></div>
      <div
        className="flex flex-col pl-8"
        data-testid={`${testId}-right-container`}
      >
        {rightColumn}
      </div>
    </div>
  );
};

const LeftColumn: React.FC<ColumnProps> = ({ children }) => {
  return <>{children}</>;
};

const RightColumn: React.FC<ColumnProps> = ({ children }) => {
  return <>{children}</>;
};

export const TwoColumnLayout = {
  Root,
  LeftColumn,
  RightColumn,
};

export default TwoColumnLayout;
